/** 页面信息 */
const page = new (function () {
  this.title = '案件申请'
  this.icon = 'iconfont iconicon_group'
  this.name = 'penalize_register_approvalCase'
  /**菜单编号 */
  this.code = 'penalize_register_approvalCase'
  /**菜单别名 */
  this.aliasName = 'penalize_register_approvalCase'
  /**路由地址 */
  this.path = '/penalize/approvalCase'
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./index.vue')
}

export default page
